import React from "react";
import HomeNav from "components/Navbars/HomeNav.js";
import { Link } from 'react-router-dom';
// reactstrap components
import {
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardText,
  Container,
  Row,
  Col,  
} from "reactstrap";

// core components
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";


function DonorConsent() {
  
  React.useEffect(() => {
    document.title = 'Liquid Love Donor Consent';
    document.body.classList.add("landing-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("landing-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);
  return (
    <>       
      <div className="wrapper">
        <HomePageHeader/>
        <HomeNav />        
        <div              
              style={{
                backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                minHeight: "700px",
              }}
        >
        <div className="text-center">
        <div style={{color: "white"}}><h3 className="title">Liquid Love</h3></div>
          <Link to="/liquidlove/donor" className="btn btn-primary">I volunteer to register as Blood Donor</Link>
        </div>
        <div >
          <Container>            
            <div className="team text-center">
              <Row>
                <Col md="4">
                  <div className="team-player">
                  <Card style={{ width: "20rem" }}>
                    
                    <CardImg alt="..." src={require("assets/img/bd1.jpg")} top></CardImg>
                    <CardBody>
                      <CardTitle tag="h4">Blood donation eligibility requirements</CardTitle>
                      <CardText align="left">
                      <li>Donor must be in the age group of 18 to 60 years.</li>
                      <li>Weight not less than 45 kgs.</li>
                      <li>Normal temperature, BP and pulse.</li>                                           
                      </CardText>
                      <Link to={{ pathname: "http://nbtc.naco.gov.in/page/eligibility/"  }} target="_blank"
                      className="btn btn-primary">Read more...</Link>
                    </CardBody>
                  </Card>                                       
                  </div>
                </Col>
                <Col md="4"></Col>
                <Col md="4">
                  <div className="team-player">
                  <Card style={{ width: "20rem" }}>
                    <CardImg alt="..." src={require("assets/img/bd2.jpg")} top></CardImg>
                    <CardBody>
                      <CardTitle tag="h4">Benefits of Blood donation</CardTitle>
                      <CardText align="left">
                      <li>Promotes heart health.</li>
                      <li>Reduces risk of liver damage.</li>
                      <li>Manages blood pressure.</li>
                      <li>Stimulates blood cell production.</li>
                      </CardText>
                      <Link to={{ pathname: "https://www.eraktkosh.in/BLDAHIMS/bloodbank/donateblood.cnt" }} target="_blank"
                      className="btn btn-primary">Read more...</Link>
                    </CardBody>
                  </Card>                    
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        </div>
        <DefaultFooter />
      </div>
    </>
  );
}

export default DonorConsent;
